import { PROTOCOL_AND_HOST } from "@/utils/constants";
import demoSongs from "@/utils/demoSongs";
import type { Song, SongId } from "@/utils/types";

const DEBUG = false;

export default async function fetchSongByID(songId: SongId): Promise<Song> {
  if (songId === "shell") {
    const song = demoSongs.songs[6];
    if (DEBUG)
      console.debug("fetchSongByID <--> SHELL / TwinkleTwinkle", {
        songId,
        title: song.title,
      });
    return {
      ...song,
      title: "SHELL",
    };
  }
  if (demoSongs.songs[songId]) {
    const song = demoSongs.songs[songId];
    if (DEBUG)
      console.debug("fetchSongByID <--> DEMO song", {
        songId,
        title: song.title,
      });
    return song;
  }
  const url = `${PROTOCOL_AND_HOST}/api/song/${songId}`;
  if (DEBUG) console.debug("🔎 --> fetchSongById", { url });
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`<-- Failed to fetch song ${songId}`);
  }
  const song = await response.json();
  if (DEBUG) console.debug("🔍 <-- fetchSongById", { url, title: song.title });
  return song;
}
